import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { ApiService } from './api.service';

export const authGuard: CanActivateFn = () => {
  const api = inject(ApiService);
  const router = inject(Router);

  if (api.isAuthenticated()) {
    return true;
  }

  return router.parseUrl('/login');
};

export const guestGuard: CanActivateFn = () => {
  const api = inject(ApiService);
  const router = inject(Router);
  return api.isAuthenticated() ? router.parseUrl('/') : true;
};

export const drainlayerGuard: CanActivateFn = () => {
  const api = inject(ApiService);
  const router = inject(Router);

  if (!api.isAuthenticated()) return router.parseUrl('/login');
  return String(api.currentUser()?.role || '') === 'Drainlayer'
    ? true
    : router.parseUrl('/');
};
